import React from 'react';
import { Container, Box, Divider, Heading } from '@hover/blueprint';
import { nanoid } from 'nanoid';
import { HOW_HOVER_WORKS_LIST_DATA } from '../../../constants';
import HowHoverWorksHeader from './HowHoverWorksHeader';

interface Props {
  currentTab: number;
  resetTimer: (title: number) => void;
}

const HowItWorksMobileTabs: React.FC<Props> = ({ currentTab, resetTimer }) => {
  const onSelectTab = (title: number) => {
    resetTimer(title);
  };

  return (
    <Container
      maxW="100%"
      centerContent
      px={200}
      d={{ base: 'flex', tablet: 'none' }}
    >
      <HowHoverWorksHeader />
      <Container
        d="flex"
        position="relative"
        alignItems="center"
        justifyContent="space-between"
        px={0}
        mb="56px"
      >
        <Divider
          position="absolute"
          w="100%"
          zIndex={1}
          color="neutral.100"
          my={0}
        />
        {HOW_HOVER_WORKS_LIST_DATA.map(listItem => {
          const isCurrent = listItem.id === currentTab;
          return (
            <Box
              cursor="pointer"
              zIndex={2}
              onClick={() => onSelectTab(listItem.id)}
              bg={isCurrent ? 'red.100' : 'neutral.200'}
              w={300}
              h={300}
              borderRadius="50%"
              alignItems="center"
              justifyContent="center"
              shadow={isCurrent ? 'distance300' : 'none'}
            >
              <Heading
                size={300}
                marginBottom={0}
                color={isCurrent ? 'red.500' : 'neutral.500'}
              >
                {listItem.id + 1}
              </Heading>
            </Box>
          );
        })}
      </Container>
      <Container px={0} centerContent>
        {HOW_HOVER_WORKS_LIST_DATA.map(listItem => (
          <Box
            d={listItem.id === currentTab ? 'flex' : 'none'}
            flexDir="column"
          >
            <Box
              key={listItem.id}
              alignItems="center"
              justifyContent="center"
              w="100%"
            >
              <Box maxH="355px" key={nanoid()}>
                {listItem.mobileImage}
              </Box>
            </Box>
            <Heading
              mt={500}
              size={300}
              isDisplay
              marginBottom={0}
              textAlign="center"
            >
              {listItem.body}
            </Heading>
          </Box>
        ))}
      </Container>
    </Container>
  );
};

export default HowItWorksMobileTabs;
